import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function WeatherNightFreezingRain(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0_1979_2878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9 9.3h-.8c-1.9 0-3.9-.7-5.3-2.2-1.7-1.7-2.4-3.9-2.2-6.1 0-.5-.5-1-1-1-.2 0-.3 0-.4.1-.3.2-.7.5-1 .8-2.3 2.3-2.8 5.7-1.5 8.5a.577.577 0 01.094.229c-1.596.644-2.864 1.96-3.494 3.571h-.4c-1.1 0-2.1.4-2.8 1.2-.8.8-1.2 1.8-1.2 2.8 0 1 .4 2.1 1.2 2.8 0 0 .8.7 1.6-.1.7-.7-.2-1.3-.2-1.3-.4-.4-.6-.9-.6-1.4 0-.5.2-1 .6-1.4.4-.4.9-.6 1.4-.6h2c0-2.2 1.8-4 4-4s4 1.8 4 4v2h3c.3 0 .5.1.7.3.2.2.3.4.3.7 0 .3-.1.5-.3.7-.2.2-.4.3-.7.3H18s-1 0-1 1 1 1 1 1h.9c.8 0 1.6-.3 2.1-.9.6-.6.9-1.3.9-2.1s-.3-1.6-.8-2.1c-.6-.6-1.3-.9-2.1-.9-.4 0-.7.1-1 .2v-.2c0-.545-.074-1.074-.212-1.577 1.495-.203 2.916-.927 4.112-2.123.3-.3.6-.6.8-1 .4-.4-.2-1.2-.8-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03 21.45c-.1-.38.12-.77.51-.87l1.59-.43L6.96 19a.7.7 0 010-1c.27-.3.74-.3 1.04 0l1.14 1.14.41-1.58c.1-.39.5-.62.88-.51.39.1.62.5.5.88l-.43 1.57 1.6-.4c.4-.1.78.11.9.5a.74.74 0 01-.53.87l-1.58.42 1.16 1.16c.28.27.28.74 0 1.02s-.74.28-1.02 0L9.87 21.9l-.42 1.6c-.1.38-.5.6-.88.5-.39-.1-.6-.5-.51-.88l.44-1.57-1.59.41c-.41.1-.78-.12-.88-.51zM16.68 22.21c0 .99-.77 1.79-1.73 1.79-.95 0-1.72-.8-1.72-1.79 0-1.18 1.72-3.18 1.72-3.18s1.73 2 1.73 3.18z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0_1979_2878"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(WeatherNightFreezingRain);
export default ForwardRef;